import React from 'react';
import { Home, Users, BookOpen, Calendar, HelpCircle, User, DollarSign } from 'lucide-react';
import Logo from '../assets/trans-logo.png'

export default function TeacherSidebar({ teacherName, onViewChange, activeView }) {
  const navItems = [
    { icon: Home, text: 'Home', view: 'home' },
    { icon: Users, text: 'Students', view: 'students' },
    { icon: BookOpen, text: 'Classes', view: 'classes' },
    { icon: Calendar, text: 'Schedule', view: 'schedule' },
    { icon: DollarSign, text: 'Payout', view: 'payout' },
    { icon: HelpCircle, text: 'Help', view: 'help' },
  ];

  return (
    <div className="bg-gray-800 text-white w-16 md:w-64 flex flex-col h-screen">
      <div className="flex items-center justify-center md:justify-start space-x-2 px-4 py-5">
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"> <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path> </svg>
        <span className="hidden md:inline text-2xl font-extrabold">Akademix</span>
      </div>
      <nav className="flex-1">
        <button
          onClick={() => onViewChange('profile')}
          className="w-full flex items-center justify-center md:justify-start py-2.5 px-4 transition duration-200 hover:bg-gray-700 hover:text-white"
        >
          <User className="w-6 h-6 md:mr-2" />
          <span className="hidden md:inline">{teacherName}</span>
        </button>
        {navItems.map((item) => (
          <button
            key={item.view}
            onClick={() => onViewChange(item.view)}
            className={`w-full flex items-center justify-center md:justify-start py-2.5 px-4 transition duration-200 ${
              activeView === item.view ? 'bg-gray-700 text-white' : 'hover:bg-gray-700 hover:text-white'
            }`}
          >
            <item.icon className="w-6 h-6 md:mr-2" />
            <span className="hidden md:inline">{item.text}</span>
          </button>
        ))}
      </nav>
    </div>
  );
}